// AsideMenuMain.tsx
import React from 'react';

export function AsideMenuMain() {
  return <div className="menu menu-column" />;
}
